module.exports = __webpack_public_path__ + "static/media/PacMan.8631702d.gif";